module.exports = __webpack_public_path__ + "img/Axe.3e308d37.png";